var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadRecept({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.856,
    height: 18,
    viewBox: "0 0 16.856 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-download-file-6847913",
    d: "M63.761,20.177a.422.422,0,1,1-.844,0V13.345H53.941l-3.314,3.314v13H59.9a.422.422,0,1,1,0,.844h-9.69a.422.422,0,0,1-.422-.422v-13.6a.421.421,0,0,1,.124-.3l3.557-3.557a.42.42,0,0,1,.3-.127h9.573a.422.422,0,0,1,.422.422v7.253Zm-.422,9.306,1.86-1.86h-.77a.422.422,0,0,1-.422-.422V23.033H62.671V27.2a.422.422,0,0,1-.422.422h-.77l1.86,1.86ZM66.516,27.5l-2.879,2.878a.421.421,0,0,1-.6,0L60.166,27.5a.422.422,0,0,1,.3-.724h1.366V22.61a.422.422,0,0,1,.422-.422H64.43a.422.422,0,0,1,.422.422v4.168h1.366a.422.422,0,0,1,.3.72Zm-12.98-5.742a.422.422,0,0,1,0-.844H60.01a.422.422,0,1,1,0,.844Zm0-2.655a.422.422,0,0,1,0-.844H60.01a.422.422,0,1,1,0,.844Z",
    transform: "translate(-49.784 -12.502)",
    fill: "#038de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRecept);
export default __webpack_public_path__ + "static/media/downloadRecept.d3e4d987047eaf6cdaaf1c7961475fb0.svg";
export { ForwardRef as ReactComponent };